/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const loginPostRequestSchema = z.object({
  client: z.string(),
  client_secret: z.string(),
  password: z.string(),
  refresh_token: z.string().optional(),
  username: z.string(),
});
